<template>
    <div>
        <v-app-bar>
            <div class="logo">
                <router-link to="/"><img class="logo mt-2" src="https://cdn.enra.app/site/img/logo-enra.svg"/>
                </router-link>
            </div>
            <v-spacer></v-spacer>
            <router-link to="/login" class="text-decoration-none float-right">
                <v-btn v-if="!auth" color="third" class="white--text">Login</v-btn>
            </router-link>
        </v-app-bar>
        <div class="container-text">
            <img src="./../img/background.jpg">
            <div class="imgText">
                <strong class="title-text pa-2 mt-8">
                    Sales 4.0 - Die Zukunft des B2B-Vertriebs</strong>
                <p class="mt-10">
                    Die Digitalisierung im B2B-Vertrieb beschäftigt unsere
                    Unternehmenslandschaft zunehmend - wir haben für Sie eine
                    <b>Wissensdatenbank mit Implementierungsansätzen zusammengestellt </b>und
                    teilen unsere Erfahrung bezüglich der Weiterentwicklung von
                    Vertriebsansätzen.
                </p>
            </div>
        </div>
    </div>
</template>

<style scoped>
    .title-text {
        font-size: 1.3rem;
        line-height: 1.5;
        text-transform: uppercase;
        background-color: #e45364;
        color: white;
        font-weight: 900;
    }

    .float-right {
        float: right;
    }

    .logo img {
        width: 150px;
        padding: 20px;
    }

    .container-text {
        position: relative;
        text-align: center;
        color: white;
    }

    .container-text img {
        width: 100%;
        height: 400px;
        object-fit: cover;
    }

    .imgText {
        width: 90%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    @media only screen and (min-width: 370px) {
        .title-text {
            font-size: 1.5rem;

        }
    }

    @media (min-width: 992px) {
        .title-text {
            font-size: 2rem;
            line-height: normal;
        }
        .imgText {
            width: 60%;
        }
    }
</style>

<script>
    import firebase from "firebase";

    export default {
        data: () => ({
            auth: false,
        }),
        mounted() {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    this.auth = true;
                    // console.log("IN");
                } else {
                    this.auth = false;
                    // console.log("OUT");
                }
            });
        },
    };
</script>